__turbopack_context__.v({
  "bottomLine": "PlansScreenFooter-module-scss-module__Qkt2ZG__bottomLine",
  "copyright": "PlansScreenFooter-module-scss-module__Qkt2ZG__copyright",
  "disclaimer": "PlansScreenFooter-module-scss-module__Qkt2ZG__disclaimer",
  "footer": "PlansScreenFooter-module-scss-module__Qkt2ZG__footer",
  "links": "PlansScreenFooter-module-scss-module__Qkt2ZG__links",
});
